import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map, TileLayer, ZoomControl } from 'react-leaflet';
import $ from 'jquery';

import { arraysEqual, trackEvent } from '~/core/scripts/utils';
import Icon from '~/core/scripts/components/Icon';
import { disableMap, enableMap } from '~/core/scripts/map-components/utils';
import LabelsLayer from '~/core/scripts/map-components/LabelsLayer';

import 'leaflet/dist/leaflet.css';

const html = document.querySelector('html');

let isInitZoom = true;

class MapComponent extends PureComponent {
  static propTypes = {
    center: PropTypes.array,
    minZoom: PropTypes.number,
    maxZoom: PropTypes.number,
    zoomSnap: PropTypes.number,
    zoomDelta: PropTypes.number,
    maxBounds: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
    fitBounds: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),

    zoomControl: PropTypes.string,

    showGeocoder: PropTypes.bool,
    zoomAfterGeocode: PropTypes.number,

    showBasemap: PropTypes.bool,
    basemapUrl: PropTypes.string,
    basemapAttribution: PropTypes.string,

    showLabels: PropTypes.bool,
    zoomAnimation: PropTypes.bool
  }

  static defaultProps = {
    minZoom: 9,
    maxZoom: 15,
    zoomDelta: 0.25,
    zoomSnap: 0.25,
    maxBounds: null,
    fitBounds: null,

    zoomControl: 'bottomright',

    showBasemap: false,
    basemapUrl: '',
    basemapAttribution: '',

    showGeocoder: false,
    zoomAfterGeocode: 11,

    showLabels: true
  }

  state = {
    isMapActive: false
  }

  constructor() {
    super();

    // we only want to set fitBounds once
    this.initFitBounds = false;
    this.isInitZoom = true;
  }

  componentDidMount() {
    if (!this.state.isMapActive) {
      disableMap(this.map.leafletElement);
    }

    this.handleLabels();
  }

  componentDidUpdate(prevProps) {
    if (!arraysEqual(this.props.geocoderLatLng, prevProps.geocoderLatLng)) {
      this.map.leafletElement.setView(this.props.geocoderLatLng, this.props.zoomAfterGeocode);
    }

    if (!this.initFitBounds && this.props.fitBounds) {
      this.map.leafletElement.fitBounds(this.props.fitBounds);
      this.initFitBounds = true;
    }
  }

  renderZoomControl() {
    if (!this.props.zoomControl) {
      return null;
    }

    return <ZoomControl position={this.props.zoomControl} />;
  }

  renderBasemap() {
    if (!this.props.showBasemap) {
      return null;
    }

    return (
      <TileLayer
        url={this.props.basemapUrl}
        attribution={this.props.basemapAttribution}
      />
    );
  }

  renderMapToggleButton() {
    if (!this.props.showMapToggleButton) {
      return null;
    }

    return (
      <button className="maptoggle" onClick={this.toggleMapActive}>
        {this.state.isMapActive ?
          <div><Icon type="scroll" /> Scrollen aktivieren</div> :
          <div><Icon type="move" /> Karte aktivieren</div>
        }
      </button>
    )
  }

  renderLabels() {
    if (!this.props.showLabels) {
      return null;
    }

    return (
      <LabelsLayer
        preset={this.props.labelPreset}
        labels={this.props.customLabels}
      />
    );
  }

  toggleMapActive = () => {
    if (!this.map) {
      return false;
    }
    if (this.state.isMapActive) {
      disableMap(this.map.leafletElement);
    } else {
      enableMap(this.map.leafletElement);
    }

    const isMapActive = !this.state.isMapActive;
    this.setState({ isMapActive });
    $('html').toggleClass('is-map-active', isMapActive);
  }

  onZoomStart() {
    html.classList.add('is-zooming');

    if (isInitZoom) {
      isInitZoom = false;
      return false;
    }

    trackEvent('zoom_start', 1, 'class_C');
  }

  onZoomEnd = () => {
    html.classList.remove('is-zooming');
    this.handleLabels();
  }

  handleLabels() {
    const labels = document.querySelectorAll('.map-label');
    const labelsVisible = this.map.leafletElement.getZoom() < 7.5;

    [].forEach.call(labels, el => el.style.opacity = labelsVisible ? 1 : 0);
  }

  render() {
    return (
      <Map
        className="map"
        ref={ref => { this.map = ref; }}
        zoomControl={false}
        zoomDelta={this.props.zoomDelta}
        zoomSnap={this.props.zoomSnap}
        minZoom={this.props.minZoom}
        maxZoom={this.props.maxZoom}
        maxBounds={this.props.maxBounds}
        zoomAnimation={this.props.zoomAnimation}
        onZoomStart={this.onZoomStart}
        onZoomEnd={this.onZoomEnd}
      >
        {this.renderZoomControl()}
        {this.renderBasemap()}
        {this.props.children}
        {this.renderLabels()}
        {this.renderMapToggleButton()}
      </Map>
    );
  }
}

export default MapComponent;
